import { Box } from '@mui/material';
import { useSetRecoilState } from 'recoil';
import { replanningEditingStructuresState } from '~/state/atoms/adaptiveReplanningAtoms';
import ReplanningDatasetList from './ReplanningDatasetList';

export default function SelectionStage() {
    const setEditing = useSetRecoilState(replanningEditingStructuresState);

    return (
        <Box height="100%" overflow="auto">
            <ReplanningDatasetList
                onEditStructureSet={() => setEditing(true)}
            />
        </Box>
    );
}
